export default "https://assets.egbcdn.net/assets/packs/_/images/logos/egb-logo-2314421f1ea7ee3b7ab2a0cb2f6ecab9.svg";